import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Moment from 'moment';

import BarChart from './BarChart';
import './Stats.scss';

class RunDuration extends Component {
  render () {
    const {interval} = this.props;
    const labelKey = interval.toLowerCase();
    const valueKey = 'duration';
    const options = {
      scales: {
        yAxes: [
          {
            ticks: {
              callback: (v)=> this.toMinutes(v),
              beginAtZero: true,
              stepSize: 60
            }
          }
        ]
      }
    };

    return (
      <div className="RunDuration">
        <BarChart
          className="RunDuration"
          queryName="statsRunDuration"
          variables={this.props}
          valueKey={valueKey}
          labelKey={labelKey}
          options={options}
        />
      </div>
    );
  }

  toMinutes = (seconds)=> {
    return Moment().startOf('day').seconds(seconds).format('mm:ss');
  }
}

RunDuration.propTypes = {
  group: PropTypes.string,
  interval: PropTypes.string
};

export default RunDuration;
